
import {Component, Prop, Vue} from "vue-property-decorator";
import { accountApi } from "@/services/api/account/account";
import AnonymousLayout from "@/layouts/AnonymousLayout.vue";
import {ConfirmEmailCommand} from "@/services/api/models/ConfirmEmailCommand.model";

@Component({
  components: {AnonymousLayout}
})
export default class ConfirmEmail extends Vue {
    
  async mounted() {
    const userId = this.$route.query.userId as string;
    const code = this.$route.query.code as string;
    
    try {
      const response = await accountApi.confirmEmail(new ConfirmEmailCommand(userId, code)); 
      window.console.log(response);
      await this.$router.push({name: "Login"});
    } catch (err) {
        window.console.log(err.message)
    }
  }
}

